module.exports = __webpack_public_path__ + "static/img/send.dda4d2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chat/images/send.png
// module id = cDN2
// module chunks = 1